import * as PIXI from "pixi.js";
import { Assets } from "pixi.js";
import { bundlingUtils } from "./BundlingUtils";
import { SoundLoadConfig } from "./shared/UI/SoundManagerUtils";
import { GameAssets } from "./shared/util/GameAssets";

import loadingAtlasUrl from "url:../assets/textures/atlas/loadingAtlas.json";
import loadingAtlasPngUrl from "url:../assets/textures/atlas/loadingAtlas.png";
import panelUrl from "url:../assets/textures/Panel.webp";
import introBgUrl from "url:../assets/textures/introBg.webp";
import mainBgUrl from "url:../assets/textures/mainBg.webp";
import coinAtlasUrl from "url:../assets/textures/coin/coin_atlas.json";
import coinAtlasPngUrl from "url:../assets/textures/coin/coin_atlas.png";
// import gameAtlasUrl from "url:../assets/textures/atlas/gameAtlas.json";
// import gameAtlasPngUrl from "url:../assets/textures/atlas/gameAtlas.png";
import uiAtlasJsonUrl from "url:../assets/textures/uiAtlas.json";
import uiAtlasImageUrl from "url:../assets/textures/uiAtlas.webp";
import winFontUrl from "url:../assets/fonts/winFont.json";
import winFontPngUrl from "url:../assets/fonts/winFont.png";
import fastButtonOnUrl from "url:../assets/UI/fastOn.png";
import fastButtonOffUrl from "url:../assets/UI/fastOff.png";
import spinButtonNewUrl from "url:../assets/UI/spinButton.png";
import buyButtonNewUrl from "url:../assets/UI/buyButton.png";
import betButtonNewUrl from "url:../assets/UI/betButton.png";
import bottomBarNewUrl from "url:../assets/UI/bottomBar.png";
import bottomBarPortraitUrl from "url:../assets/UI/bottomBarPortrait.png";
import autoplayButtonUrl from "url:../assets/UI/autoplayButton.png";
import amountBackgroundUrl from "url:../assets/UI/amountBackground.png";
import stopButtonNewUrl from "url:../assets/UI/stopButton.png";
import soundButtonOnUrl from "url:../assets/UI/soundOn.png";
import soundButtonOffUrl from "url:../assets/UI/soundOff.png";
import infoButtonUrl from "url:../assets/UI/info.png";

import sevenJsonUrl from "url:../assets/spine/seven.json";
import sevenAtlasUrl from "url:../assets/spine/seven.atlas";
import sevenAtlasPngUrl from "url:../assets/spine/seven.webp";
import bellJsonUrl from "url:../assets/spine/bell.json";
import bellAtlasUrl from "url:../assets/spine/bell.atlas";
import bellAtlasPngUrl from "url:../assets/spine/bell.webp";
import cloverJsonUrl from "url:../assets/spine/clover.json";
import cloverAtlasUrl from "url:../assets/spine/clover.atlas";
import cloverAtlasPngUrl from "url:../assets/spine/clover.webp";
import starJsonUrl from "url:../assets/spine/star.json";
import starAtlasUrl from "url:../assets/spine/star.atlas";
import starAtlasPngUrl from "url:../assets/spine/star.webp";
import crownJsonUrl from "url:../assets/spine/crown.json";
import crownAtlasUrl from "url:../assets/spine/crown.atlas";
import crownAtlasPngUrl from "url:../assets/spine/crown.webp";
import dollarJsonUrl from "url:../assets/spine/dollar.json";
import dollarAtlasUrl from "url:../assets/spine/dollar.atlas";
import dollarAtlasPngUrl from "url:../assets/spine/dollar.webp";
import lowsJsonUrl from "url:../assets/spine/lows.json";
import lowsAtlasUrl from "url:../assets/spine/lows.atlas";
import lowsAtlasPngUrl from "url:../assets/spine/lows.webp";
import wildJsonUrl from "url:../assets/spine/wild.json";
import wildAtlasUrl from "url:../assets/spine/wild.atlas";
import wildAtlasPngUrl from "url:../assets/spine/wild.webp";
import winsJsonUrl from "url:../assets/spine/wins.json";
import winsAtlasUrl from "url:../assets/spine/wins.atlas";
import winsAtlasPngUrl from "url:../assets/spine/wins.webp";

import paylinesJsonUrl from "url:../assets/spine/paylines.json";
import paylinesAtlasUrl from "url:../assets/spine/paylines.atlas";
import paylinesAtlasPngUrl from "url:../assets/spine/paylines.webp";


import bulbsJsonUrl from "url:../assets/spine/panel_bulbs.json";
import bulbsAtlasUrl from "url:../assets/spine/panel_bulbs.atlas";
import bulbsAtlasPngUrl from "url:../assets/spine/panel_bulbs.webp";

import logoJsonUrl from "url:../assets/spine/logo.json";
import logoAtlasUrl from "url:../assets/spine/logo.atlas";
import logoAtlasPngUrl from "url:../assets/spine/logo.webp";

import anticipationJsonUrl from "url:../assets/spine/antic.json";
import anticipationAtlasUrl from "url:../assets/spine/antic.atlas";
import anticipationAtlasPngUrl from "url:../assets/spine/antic.png";

import coinLoopUrl from "url:../assets/audio/coinLoop.m4a";
import musicMainUrl from "url:../assets/audio/musicMain.m4a";
import startGameUrl from "url:../assets/audio/startGame.m4a";
import winBigUrl from "url:../assets/audio/winBig.m4a";
import winMegaUrl from "url:../assets/audio/winMega.m4a";
import winNormalUrl from "url:../assets/audio/winNormal.m4a";
import winSmallUrl from "url:../assets/audio/winSmall.m4a";
import winSuperUrl from "url:../assets/audio/winSuper.m4a";
import winEndUrl from "url:../assets/audio/winEnd.m4a";
import buttonClickUrl from "url:../assets/audio/buttonClick.m4a";
import paylineShowUrl from "url:../assets/audio/payLine.m4a";
import matchShowUrl from "url:../assets/audio/match.m4a";
import reelSpinLoopUrl from "url:../assets/audio/reelSpinLoop.m4a";
import reelStopUrl from "url:../assets/audio/reelStop.m4a";
import anticipationUrl from "url:../assets/audio/anticipation.m4a";
import appearingWildUrl from "url:../assets/audio/appearingWild.m4a";
import expandingWildUrl from "url:../assets/audio/expandingWild.m4a";

import uiFontUrl from "url:../assets/fonts/Roboto_Condensed-Regular.ttf";
import textFontUrl from "url:../assets/fonts/Besley-Bold.ttf";
import lcdFontUrl from "url:../assets/fonts/VT323-Regular.ttf";

import dollarSymbolUrl from "url:../assets/symbols/Dollar.png";
import starSymbolUrl from "url:../assets/symbols/Star.png";
import sevenSymbolUrl from "url:../assets/symbols/Seven.png";
import grapesSymbolUrl from "url:../assets/symbols/Grapes.png";
import watermelonSymbolUrl from "url:../assets/symbols/Watermelon.png";
import bellSymbolUrl from "url:../assets/symbols/Bell.png";
import plumSymbolUrl from "url:../assets/symbols/Plum.png";
import orangeSymbolUrl from "url:../assets/symbols/Orange.png";
import lemonSymbolUrl from "url:../assets/symbols/Lemon.png";
import cherrySymbolUrl from "url:../assets/symbols/Cherry.png";
import wildsDemoUrl from "url:../assets/symbols/WildsDemo.png";

import betDemoUrl from "url:../assets/BetDemonstration.jpg";
import betwaysDemoUrl from "url:../assets/Betways.jpg";
import { soundManager } from "./shared/UI/SoundManager";

// NOTE: The files that need manual processing must not be added to any bundle, and must be created and processed manually
// I.e. createSpineAtlas, createBitmapFont, createSpritesheet
class GameAssetManager {
  private static _instance: GameAssetManager;

  private _totalProgress = { textures: 0, skeletons: 0, audio: 0 };

  public static getInstance(): GameAssetManager {
    if (!this._instance) {
      this._instance = new GameAssetManager();
    }

    return this._instance;
  }

  public createGameAssetBundles(): void {
    console.log("Adding loading bundle...");

    // Loading assets
    Assets.addBundle("loading", {
      introBg: introBgUrl,
    });

    console.log("Loading bundle added successfully!");

    console.log("Adding textures bundle...");

    // Texture assets
    Assets.addBundle("textures", {
      mainBg: mainBgUrl,
      panel: panelUrl,

      fastButtonOn: fastButtonOnUrl,
      fastButtonOff: fastButtonOffUrl,
      spinButtonNew: spinButtonNewUrl,
      buyButtonNew: buyButtonNewUrl,
      betButtonNew: betButtonNewUrl,
      bottomBarNew: bottomBarNewUrl,
      bottomBarPortrait: bottomBarPortraitUrl,
      autoplayButton: autoplayButtonUrl,
      amountBackground: amountBackgroundUrl,
      stopButtonNew: stopButtonNewUrl,
      soundButtonOn: soundButtonOnUrl,
      soundButtonOff: soundButtonOffUrl,
      infoButton: infoButtonUrl,

      starSymbol: starSymbolUrl,
      dollarSymbol: dollarSymbolUrl,
      sevenSymbol: sevenSymbolUrl,
      grapesSymbol: grapesSymbolUrl,
      watermelonSymbol: watermelonSymbolUrl,
      bellSymbol: bellSymbolUrl,
      plumSymbol: plumSymbolUrl,
      orangeSymbol: orangeSymbolUrl,
      lemonSymbol: lemonSymbolUrl,
      cherrySymbol: cherrySymbolUrl,
      wildsDemo: wildsDemoUrl,
      betDemo: betDemoUrl,
      betwaysDemo: betwaysDemoUrl,
    });

    console.log("Textures bundle added successfully!");

    console.log("Adding spines bundle...");

    // Spine assets
    Assets.addBundle("spines", {
      winsJson: winsJsonUrl,
      bellJson: bellJsonUrl,
      cloverJson: cloverJsonUrl,
      crownJson: crownJsonUrl,
      dollarJson: dollarJsonUrl,
      lowsJson: lowsJsonUrl,
      sevenJson: sevenJsonUrl,
      starJson: starJsonUrl,
      wildJson: wildJsonUrl,
      paylinesJson: paylinesJsonUrl,
      bulbsJson: bulbsJsonUrl,
      logoJson: logoJsonUrl,
      anticipationJson: anticipationJsonUrl,
    });

    console.log("Spines bundle added successfully!");

    console.log("Adding audio bundle...");

    // Audio assets
    Assets.addBundle("audio", {
      coinLoop: coinLoopUrl,
      musicMain: musicMainUrl,
      winBig: winBigUrl,
      winMega: winMegaUrl,
      winNormal: winNormalUrl,
      winSmall: winSmallUrl,
      winSuper: winSuperUrl,
      winEnd: winEndUrl,
      buttonClick: buttonClickUrl,
      paylineShow: paylineShowUrl,
      matchShow: matchShowUrl,
      reelSpinLoop: reelSpinLoopUrl,
      reelStop: reelStopUrl,
      anticipation: anticipationUrl,
      appearingWild: appearingWildUrl,
      expandingWild: expandingWildUrl,
    });

    console.log("Audio bundle added successfully!");
  }

  /**
   * Load assets required for the loading screen.
   */
  public async loadLoadingScreenAssets() {
    await soundManager.createSound({ url: startGameUrl, key: "startGame" });
    const loadingAssets = await Assets.loadBundle("loading");

    // Add the spritesheet to loading assets
    loadingAssets.loadingAtlas = await bundlingUtils.createSpritesheet(
      loadingAtlasUrl,
      loadingAtlasPngUrl,
    );

    GameAssets.loading = loadingAssets;
  }

  /**
   * Load custom fonts for the game.
   */
  public async loadFonts(): Promise<void> {
    const font = new FontFace("UIFont", `url(${uiFontUrl})`);
    const textFont = new FontFace("TextFont", `url(${textFontUrl})`);
    const lcdFont = new FontFace("LcdFont", `url(${lcdFontUrl})`);

    try {
      await font.load();
      await textFont.load();
      await lcdFont.load();

      document.fonts.add(font);
      document.fonts.add(textFont);
      document.fonts.add(lcdFont);
    } catch (err) {
      console.error("Failed to load fonts:", err);
    }
  }

  /**
   * Load game assets and track loading progress.
   */
  public async loadGameAssets(progressCallback?: (progress: number) => void, completeCallback?: () => void) {
    let soundLoadingProgress: number = 0;
    let customAssetsProgress: number = 0;

    const updateProgress = () => {
      const combinedProgress =
        (this._totalProgress.textures +
          this._totalProgress.skeletons +
          this._totalProgress.audio +
          soundLoadingProgress +
          customAssetsProgress) /
        5;

      progressCallback?.(combinedProgress);
    };

    const textures = await Assets.loadBundle("textures", (progress) => {
      this._totalProgress.textures = progress;
      updateProgress();
    });

    const skeletons = await Assets.loadBundle("spines", (progress) => {
      this._totalProgress.skeletons = progress;
      updateProgress();
    });

    const audio = await Assets.loadBundle("audio", (progress) => {
      this._totalProgress.audio = progress;
      updateProgress();
    });

    await this._loadSounds((progress: number) => {
      soundLoadingProgress = progress;
      updateProgress();
    });

    await this._loadCustomGameAssets(textures, skeletons, (progress: number) => {
      customAssetsProgress = progress;
      updateProgress();
    });

    // Register ALL spine assets in PIXI's cache
    Object.keys(skeletons).forEach((key) => {
      PIXI.Assets.cache.set(key, skeletons[key]);
    });

    GameAssets.textures = textures;
    GameAssets.skeletons = skeletons;
    GameAssets.audio = audio;

    completeCallback?.();
  }

  private async _loadCustomGameAssets(
    textures: any,
    skeletons: any,
    callback: (progress: number) => void,
  ): Promise<void> {
    const assetDefs: { key: string, createFunction: () => Promise<any>, bundle: any }[] = [
      // {
      //     key: "gameAtlas",
      //     createFunction: () => bundlingUtils.createSpritesheet(gameAtlasUrl, gameAtlasPngUrl),
      //     bundle: textures,
      // },
      {
        key: "uiAtlas",
        createFunction: () => bundlingUtils.createSpritesheet(uiAtlasJsonUrl, uiAtlasImageUrl),
        bundle: textures,
      },
      {
        key: "coinAtlas",
        createFunction: () => bundlingUtils.createSpritesheet(coinAtlasUrl, coinAtlasPngUrl),
        bundle: textures,
      },
      {
        key: "winsAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(winsAtlasUrl, winsAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "bellAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(bellAtlasUrl, bellAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "cloverAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(cloverAtlasUrl, cloverAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "crownAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(crownAtlasUrl, crownAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "dollarAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(dollarAtlasUrl, dollarAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "lowsAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(lowsAtlasUrl, lowsAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "sevenAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(sevenAtlasUrl, sevenAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "starAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(starAtlasUrl, starAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "wildAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(wildAtlasUrl, wildAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "paylinesAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(paylinesAtlasUrl, paylinesAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "bulbsAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(bulbsAtlasUrl, bulbsAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "logoAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(logoAtlasUrl, logoAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "anticipationAtlas",
        createFunction: () => bundlingUtils.createSpineAtlas(anticipationAtlasUrl, anticipationAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "font",
        createFunction: () => bundlingUtils.createBitmapFont(winFontUrl, winFontPngUrl, "WinFont"),
        bundle: null,
      },
    ];

    const total: number = assetDefs.length;
    let completed: number = 0;

    const wrappedPromises = assetDefs.map((data) =>
      data.createFunction().then((result: any) => {
        if (data.bundle) {
          data.bundle[data.key] = result;
        }
        completed++;
        callback(completed / total);
      }),
    );

    await Promise.all(wrappedPromises);
  }

  private async _loadSounds(
    callback: (progress: number) => void,
  ): Promise<void> {
    const soundDefs: SoundLoadConfig[] = [
      { url: musicMainUrl, key: "musicMain", loop: true, volume: 0.6 },
      { url: winBigUrl, key: "winBig" },
      { url: winMegaUrl, key: "winMega" },
      { url: winNormalUrl, key: "winNormal" },
      { url: winSuperUrl, key: "winSuper" },
      { url: winSmallUrl, key: "winSmall" },
      { url: winEndUrl, key: "winEnd" },
      { url: buttonClickUrl, key: "buttonClick" },
      { url: paylineShowUrl, key: "paylineShow" },
      { url: matchShowUrl, key: "matchShow", volume: 0.7 },
      { url: reelSpinLoopUrl, key: "reelSpinLoop", loop: true, volume: 0.5 },
      { url: reelStopUrl, key: "reelStop", volume: 0.5 },
      { url: coinLoopUrl, key: "coinLoop", loop: true },
      { url: anticipationUrl, key: "anticipation" },
      { url: appearingWildUrl, key: "appearingWild" },
      { url: expandingWildUrl, key: "expandingWild" },
    ];

    const total: number = soundDefs.length;
    let completed: number = 0;

    const wrappedPromises = soundDefs.map(
      (loadConfig) =>
        soundManager.createSound(loadConfig).then(() => {
          completed++;
          callback(completed / total);
        }),
    );

    await Promise.all(wrappedPromises);
  }

}


export const gameAssetManager = GameAssetManager.getInstance();
